<template>
  <div>
    <div v-if="wrapFormItem">
      <el-form-item :label="label">

        <el-upload
        :ref="this.refs"
        :action="this.url"
        :drag="drag"
        :multiple="multiple"
        :http-request="customUpload"
        :headers="headers"
        :on-remove="remove"
        :on-error="error"
        :on-preview="download"
        :on-success="success"
        :before-upload="prepareUpload"
        :file-list="model"
        :list-type="listType"
        :limit="limit"
        :disabled="!allowUpload">

        <el-tooltip v-if="showTooltip"
          effect="dark"
          :content="tooltip"
          placement="right-start">

          <el-button
            :size="size"
            :type="type"
            :icon="icon"
            :disabled="!allowUpload">{{text}}</el-button>

        </el-tooltip>

        <el-button v-else
          :size="size"
          :type="type"
          :icon="icon"
          :disabled="!allowUpload">{{text}}</el-button>

<!--
  // BUG not working.

          <el-button v-if="!this.multiple && this.showDelete && this.files.length === 1"
           type="danger":size="size"
           icon="fa fa-trash-alt" @click="singleDelete" />

           <el-button v-if="!this.multiple && this.showDelete && this.files.length > 1"
            type="danger":size="size"
            icon="fa fa-clone" @click="deleteAll">Delete All</el-button>
-->
      </el-upload>
    </el-form-item>
  </div>

  <div v-else>
    <el-upload
    :action="this.url"
    :multiple="multiple"
    :on-remove="removeFunc"
    :on-success="success"
    :on-preview="download"
    :on-exceed="fileLimits"
    :http-request="customUpload"
    :headers="headers"
    :before-upload="prepareUpload"
    :file-list="model"
    :list-type="listType"
    :limit="limit"
    :disabled="!allowUpload">

    <el-tooltip v-if="showTooltip" effect="dark" :content="tooltip" placement="right-start">

      <el-button :size="size" :type="type" :icon="icon"
      :disabled="!allowUpload">{{text}}</el-button>

    </el-tooltip>

    <el-button v-else :size="size" :type="type" :icon="icon"
    :disabled="!allowUpload">{{text}}</el-button>
    <el-button v-if="!this.multiple && this.showDelete && this.files.length === 1"
     type="danger":size="size"
     icon="fa fa-trash-alt" @click="singleDelete" />
     <el-button v-if="!this.multiple && this.showDelete && this.files.length > 1"
      type="danger":size="size"
      icon="fa fa-clone" @click="deleteAll">Delete All</el-button>

  </el-upload>
  </div>

</div>
</template>

<script>

import PostMixins from '@/mixins/PostMixins'

import FormattingMixins from '@/mixins/FormattingMixins'
import ArrayMixins from '@/mixins/ArrayMixins'

import axios from '@/lib/axiosClient'

export default {
  name: 'file-upload',

  mixins: [ArrayMixins, FormattingMixins, PostMixins],

  props: {
    url: {
      type: String,
      required: true
    },

    model: {
      type: Array,
      required: true
    },

    text: {
      type: String,
      default: 'Upload'
    },

    label: {
      type: String,
      default: ''
    },

    multiple: {
      type: Boolean,
      default: false
    },

    drag: {
      type: Boolean,
      default: false
    },

    thumbnail: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: 'upload'
    },

    type: {
      type: String,
      default: 'success'
    },

    showDelete: {
      type: Boolean,
      default: true
    },

    deleteFileOnly: {
      type: Boolean,
      default: false
    },

    deleteUrl: {
      type: String,
      default: null
    },

    listType: {
      type: String,
      default: 'picture',
      validator: function (val) {
        if (val && typeof val === 'string') {
          var vals = ['picture', 'picture-card', 'text']
          return vals.includes(val.toLowerCase())
        } else {
          return false
        }
      }
    },

    limit: {
      type: Number,
      default: 5
    },

    size: {
      type: String,
      default: 'medium'
    },

    tooltip: {
      type: String,
      default: 'Upload PDF or image files (png, jpg, bmp) less than 8MB in size'
    },

    showTooltip: {
      type: Boolean,
      default: true
    },

    afterUpload: {
      type: Function,
      default: null
    },

    afterDelete: {
      type: Function
    },

    wrapFormItem: {
      type: Boolean,
      default: true
    },

    additionalData: {
      type: Object,
      default: null
    }
  },

  methods: {
    success (response, file, fileList) {

      var data = response.data

      if (data && data.id) {
        var index = this.files.includes(file)
        if (index) {
          this.files[index] = data
        } else {
          this.files.push(data)
        }

        this.file = data

        if (this.afterUpload) {
          if (this.additionalData) {
            this.afterUpload(data, this.additionalData)
          } else {
            this.afterUpload(data)
          }
        }

      } else {
        this.$notify({
          type: file.response.error ? 'error' : 'warning',
          message: 'Upload failed ' + data.error ? data.error : data.warning
        })
      }

    },

    prepareUpload (file) {
      this.file = file

      if (this.file.size > 8000000) {

        this.$notify({
          title: 'File Size Limit Exceeded',
          message: `The file [${file.name}] is larger than 8MB. Can't upload.`,
          type: 'error'
        })

        return false
      }
/*
      let name = this.webSafeFileName(file.name)

      if (this.files.length > 1) {
        this.headers = []
      } else {
        this.headers = {}

        this.headers.name = name
        this.headers.type = this.file.type
        this.headers.size = this.file.size
        this.headers.uploadBy = this.userName()
        this.headers.enctype = 'multipart/form-data'
      }
*/
      for (let i = 0; i < this.files.length; i++) {

        let hd = {}
        this.files[i].name.replace(/[\\~#%&*{}/:<>?|"-]/g, '\\$&')

        hd.name = this.files[i].name
        hd.type = this.files[i].type
        hd.size = this.files[i].size
        hd.uploadBy = this.userName()
        hd.enctype = 'multipart/form-data'

//        this.headers.push(this.clone(hd))
      }

      if (this.files.length === 0) {
        this.files.push(this.file)
      }

      return true

    },

    download (file) {
      if (file && file.id) {
        return this.getEndpoint('file/download/' + file.id)
      }

    },

    deleted (response) {
      if (this.files.length === 1) {
        this.files = []
      } else {
        this.files = this.arrayRemoveById(this.files, 'url', response.data.name)
      }

      if (this.afterDelete) {
        this.afterDelete(response)
      }

    },

    singleDelete () {
      this.remove(this.files[0], this.files)
    },

    deleteAll () {
      for (var i = 0; i < this.files.length; i++) {
        this.remove(this.files[i], this.files)
      }
    },

    remove (file, fileList) {

      if (this.deleteFileOnly) {

        this.saveForm(this, '/file/delete/', file.id, file, file.name, this.deleted)

      } else {
        if (this.deleteUrl) {
          this.delete(this, '/file/' + file.url, file.name, this.deleted)
        } else {
          this.$message({message: 'No delete URL provided. Contact Tech Support please', type: 'error'})
        }
      }
    },


    error (file, fileList) {
      console.error('Upload error:', file)

      if (this.response && this.reponse.error) {
        this.$notify({
          type: file.response.error ? 'error' : 'warning',
          message: 'Upload failed ' + file.response.error ? file.response.error : file.response.warning
        })

      } else {

        if (file.type) {
          this.$notify({
            type: file.type,
            message: 'Upload failed: An error occured uploading your file. It might be the wrong type, or too large.'
          })
        }
      }
    },

    fileLimits (file, fileList) {
      this.$notify({
        type: 'warning',
        message: 'File type or size limit exceeded'
      })
    },

    async customUpload (options) {
      const formData = new FormData()
      formData.append('file', options.file)

      return axios.post(options.action, formData, options.headers)
    }
  },

  computed: {
    downloadUrl: function () {
      if (this.files && typeof this.current === 'number') {

        if (this.files && this.files[this.current].id) {
          return this.getEndpoint('file/download/' + this.files[this.current].url + '/' + this.files[this.current].name)
        }
      }
    }, // url

    allowUpload: function () {

      if (this.isViewOnly()) {
        return false
      }

      if (!this.disabled && !this.multiple && this.model && this.model.length > 0) {
        return false

      } else {
        return !this.multiple && this.model && this.model.length > 1 ? true : !this.disabled

      }

    }
  },

  data () {
    return {
      file: null,
      refs: 'upload-' + Date.now(),
      headers: {},
      files: this.model,
      deleting: null,
      removeFunc: this.deleteFunction ? this.deleteFunction : this.remove,
      current: (this.model && this.model.length > 0) ? 0 : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// FileUpload.vue?6c4584f5